(function(){
  var root = document.querySelector('.jr') || document.querySelector('[data-gnss-hub]');
  if(!root) return;

  /* Local calendar date (never UTC) — used for date input minimums */
  function localToday(){
    var d = new Date(), m = d.getMonth()+1, day = d.getDate();
    return d.getFullYear() + '-' + (m<10?'0':'') + m + '-' + (day<10?'0':'') + day;
  }
  function money(n){ return '$' + Math.round(n).toLocaleString('en-US'); }

  /* Cheapest combination of 28-day / weekly / daily blocks covering the period.
     Charging is capped by the next longer tier, so one extra day cannot spike the price. */
  function bestTier(d, day, week, mon){
    var best = null, maxM = Math.ceil(d/28), m, w, r, rem, cost;
    for(m=0; m<=maxM; m++){
      rem = Math.max(0, d - m*28);
      for(w=0; w<=Math.ceil(rem/7); w++){
        r = Math.max(0, rem - w*7);
        cost = m*mon + w*week + r*day;
        /* <= so that at an equal price the longer tier wins (4 days quotes as a week) */
        if(!best || cost <= best.cost) best = {cost:cost, m:m, w:w, d:r};
      }
    }
    return best;
  }
  function tierLabel(b){
    var parts = [];
    if(b.m) parts.push(b.m + ' × 28-day rate');
    if(b.w) parts.push(b.w + ' × weekly rate');
    if(b.d) parts.push(b.d + ' × daily rate');
    return parts.join(' + ');
  }

  /* ---------- 1. Estimator ---------- */
  var cards = [].slice.call(root.querySelectorAll('[data-fleet] [data-model]'));
  var sel  = root.querySelector('#jr-est-model');
  var days = root.querySelector('#jr-est-days');
  var qty  = root.querySelector('#jr-est-qty');
  var pole = root.querySelector('#jr-est-pole');
  var out  = root.querySelector('#jr-est-out');
  var poleEl = root.querySelector('[data-addon-pole]');
  var POLE = {
    day:   poleEl ? +poleEl.getAttribute('data-day')   : 10,
    week:  poleEl ? +poleEl.getAttribute('data-week')  : 35,
    month: poleEl ? +poleEl.getAttribute('data-month') : 75
  };

  if(sel && days && out && cards.length){
    cards.forEach(function(c,i){
      var o = document.createElement('option');
      o.value = i; o.textContent = c.getAttribute('data-model');
      sel.appendChild(o);
    });

    function num(el, min, max, fallback){
      var v = parseInt(el && el.value, 10);
      if(isNaN(v)) v = fallback;
      return Math.max(min, Math.min(max, v));
    }

    function update(){
      var c = cards[parseInt(sel.value,10) || 0];
      var d = num(days, 1, 365, 1);
      var q = num(qty, 1, 20, 1);
      var np = num(pole, 0, 20, 0);

      var rb = bestTier(d, +c.getAttribute('data-day'), +c.getAttribute('data-week'), +c.getAttribute('data-month'));
      var receiverTotal = rb.cost * q;

      /* Kits that ship with a pole (R980) cover one pole per receiver — only the extras are charged. */
      var perUnitPoles = +c.getAttribute('data-included-poles') || 0;
      var includedPoles = Math.min(np, perUnitPoles * q);
      var chargedPoles = Math.max(0, np - includedPoles);
      var poleTotal = chargedPoles > 0 ? bestTier(d, POLE.day, POLE.week, POLE.month).cost * chargedPoles : 0;

      var total = receiverTotal + poleTotal;
      var auth = (+c.getAttribute('data-deposit')) * q;

      var rows = '<ul class="jr-est__rows">';
      rows += '<li><span>' + c.getAttribute('data-model') + ' rental' + (q>1 ? ' × ' + q : '') +
              '</span><span>' + money(receiverTotal) + '</span></li>';
      if(includedPoles > 0){
        rows += '<li><span>2 m carbon-fiber pole' + (includedPoles>1 ? ' × ' + includedPoles : '') +
                ' — included with the kit</span><span>Included</span></li>';
      }
      if(chargedPoles > 0){
        rows += '<li><span>' + (includedPoles > 0 ? 'Additional 2 m pole' : '2 m carbon-fiber pole') +
                (chargedPoles>1 ? ' × ' + chargedPoles : '') +
                '</span><span>' + money(poleTotal) + '</span></li>';
      }
      rows += '<li class="jr-est__total"><span>Estimated rental total</span><span>' + money(total) + '</span></li>';
      rows += '<li class="jr-est__auth"><span>Refundable security authorization, held separately</span><span>' +
              money(auth) + '</span></li></ul>';
      rows += '<p class="jr-est__tier">' + d + (d===1?' day':' days') + ' billed as ' + tierLabel(rb) +
              ' · about ' + money(total/d) + '/day. Excludes shipping and tax.</p>';
      out.innerHTML = rows;
    }

    sel.addEventListener('change', update);
    [days, qty, pole].forEach(function(el){ if(el) el.addEventListener('input', update); });
    update();
  }

  /* ---------- 2. Form: post back to this page, sane date minimums ---------- */
  var form = root.querySelector('#jr-rental-form');
  if(form){
    
    var today = localToday();
    var st = root.querySelector('#jr-start'), en = root.querySelector('#jr-end');
    if(st){
      st.min = today;
      st.addEventListener('change', function(){
        if(!en) return;
        en.min = st.value || today;
        if(en.value && en.value < en.min) en.value = en.min;
      });
    }
    if(en) en.min = today;
  }

  /* ---------- 3. "Not sure what I need?" shortcut ---------- */
  var help = root.querySelector('#jr-help-link');
  if(help){
    help.addEventListener('click', function(){
      var eq = root.querySelector('#jr-equip'),
          cfg = root.querySelector('#jr-config'),
          box = root.querySelector('input[name="contact[Help Configuring]"]'),
          notes = root.querySelector('#jr-notes');
      if(eq){
        for(var i=0;i<eq.options.length;i++){
          if(eq.options[i].text.indexOf('Not sure') === 0){ eq.selectedIndex = i; break; }
        }
      }
      if(cfg){
        for(var k=0;k<cfg.options.length;k++){
          if(cfg.options[k].text === 'Not sure'){ cfg.selectedIndex = k; break; }
        }
      }
      if(box) box.checked = true;
      if(notes) setTimeout(function(){ notes.focus({preventScroll:true}); }, 400);
    });
  }

  /* ---------- 3b. Card and package CTAs pre-select the receiver ---------- */
  function setByText(el, text){
    if(!el || !text) return;
    for(var i=0;i<el.options.length;i++){
      if(el.options[i].text === text){ el.selectedIndex = i; return; }
    }
  }
  [].slice.call(root.querySelectorAll('[data-select-model]')).forEach(function(btn){
    btn.addEventListener('click', function(){
      setByText(root.querySelector('#jr-equip'), btn.getAttribute('data-select-model'));
      setByText(root.querySelector('#jr-config'), btn.getAttribute('data-select-config'));
    });
  });

  /* ---------- 3c. Pole-included hint when the R980 is selected ---------- */
  var equip = root.querySelector('#jr-equip');
  var poleTips = [].slice.call(root.querySelectorAll('.jr-poletip'));
  function syncPoleTip(){
    var show = equip && /R980/.test(equip.value || equip.options[equip.selectedIndex].text);
    poleTips.forEach(function(el){ el.hidden = !show; });
  }
  if(equip && poleTips.length){
    equip.addEventListener('change', syncPoleTip);
    [].slice.call(root.querySelectorAll('[data-select-model]')).forEach(function(b){
      b.addEventListener('click', function(){ setTimeout(syncPoleTip, 0); });
    });
    syncPoleTip();
  }

  /* ---------- 4. Confirmation after Shopify redirects back ---------- */
  if(window.location.search.indexOf('contact_posted=true') > -1){
    var ok = root.querySelector('#jr-success');
    if(ok){ ok.style.display = 'block'; ok.scrollIntoView({block:'center'}); }
  }
})();
